// VCG Construct — Theme JS
document.addEventListener('DOMContentLoaded', function () {

  /* Multi-step form */
  (function () {
    const form = document.getElementById('quoteForm');
    if (!form) return;
    const steps = form.querySelectorAll('.step');
    const inds = document.querySelectorAll('.steps-ind .s');
    const nextBtn = document.getElementById('nextBtn');
    const backBtn = document.getElementById('backBtn');
    const answers = {};
    let cur = 1;
    const total = steps.length;

    form.querySelectorAll('.opt').forEach(o => {
      o.addEventListener('click', () => {
        const q = o.dataset.q;
        form.querySelectorAll('.opt[data-q="' + q + '"]').forEach(x => x.classList.remove('sel'));
        o.classList.add('sel');
        answers[q] = o.dataset.v;
        setTimeout(() => { if (cur < total) go(cur + 1); }, 220);
      });
    });

    function render() {
      steps.forEach(s => s.classList.toggle('active', +s.dataset.step === cur));
      inds.forEach(i => i.classList.toggle('active', +i.dataset.s <= cur));
      backBtn.style.display = cur > 1 ? 'block' : 'none';
      nextBtn.textContent = cur === total ? (nextBtn.dataset.send || 'Envoyer ma demande') : (nextBtn.dataset.next || 'Continuer →');
    }
    function go(n) { cur = n; render(); }
    backBtn.addEventListener('click', () => { if (cur > 1) go(cur - 1); });

    nextBtn.addEventListener('click', () => {
      if (cur < total) {
        const stepEl = [...steps].find(s => +s.dataset.step === cur);
        if (stepEl.querySelector('.opt') && !stepEl.querySelector('.opt.sel')) {
          stepEl.querySelector('.sub').style.color = '#c0392b';
          return;
        }
        go(cur + 1);
      } else {
        const shopifyForm = document.getElementById('shopify-contact-form');
        const nameI = document.getElementById('f_name');
        const phoneI = document.getElementById('f_phone');
        const emailI = document.getElementById('f_email');
        const msgI = document.getElementById('f_msg');
        if (!nameI.value.trim() || !phoneI.value.trim() || !emailI.value.trim()) {
          /* 03/09/2026 : le message etait ecrit en dur en francais et s'affichait tel quel
             aux visiteurs neerlandais. Le texte traduit arrive par data-err-coords, pose
             dans le gabarit du formulaire ; la phrase francaise ne reste que par securite. */
          alert(form.dataset.errCoords || 'Merci de compléter vos coordonnées.');
          return;
        }
        if (shopifyForm) {
          // Soumission via le système contact natif Shopify
          shopifyForm.querySelector('input[name="contact[name]"]').value = nameI.value.trim();
          shopifyForm.querySelector('input[name="contact[phone]"]').value = phoneI.value.trim();
          shopifyForm.querySelector('input[name="contact[email]"]').value = emailI.value.trim();
          const body = (msgI ? msgI.value.trim() + '\n\n' : '') + 'Réponses du questionnaire :\n' + Object.keys(answers).map(k => '- ' + k + ' : ' + answers[k]).join('\n');
          shopifyForm.querySelector('textarea[name="contact[body]"]').value = body;

          // IMPORTANT : ne jamais appeler shopifyForm.submit() directement.
          // Cela contourne la protection hCaptcha de Shopify et provoque un rejet 403
          // (page d'erreur / challenge). On déclenche un vrai événement de soumission
          // (requestSubmit) pour que le bootstrap captcha de Shopify fasse son travail,
          // et on lie le captcha via l'API officielle quand elle est disponible.
          nextBtn.disabled = true;
          let fired = false;
          const fire = function () {
            if (fired) return; fired = true;
            if (typeof shopifyForm.requestSubmit === 'function') { shopifyForm.requestSubmit(); }
            else { shopifyForm.submit(); }
          };
          if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
            try { window.Shopify.captcha.protect(shopifyForm, fire); } catch (e) { fire(); }
            // Si le script captcha ne répond pas (réseau lent), on tente quand même :
            setTimeout(fire, 3500);
          } else {
            fire();
          }
        } else {
          // Fallback : pas de form Shopify (mode preview)
          console.log('Lead VCG Construct:', answers);
          steps.forEach(s => s.classList.remove('active'));
          document.getElementById('formNav').style.display = 'none';
          document.getElementById('doneMsg').classList.add('show');
          inds.forEach(i => i.classList.add('active'));
        }
      }
    });
    render();
  })();

  /* Mobile drawer */
  (function () {
    const burger = document.getElementById('burger');
    const drawer = document.getElementById('drawer');
    const overlay = document.getElementById('drawerOverlay');
    const closeBtn = document.getElementById('drawerClose');
    if (!burger || !drawer) return;
    const open = () => { document.body.classList.add('menu-open'); burger.setAttribute('aria-expanded', 'true'); drawer.setAttribute('aria-hidden', 'false'); };
    const close = () => { document.body.classList.remove('menu-open'); burger.setAttribute('aria-expanded', 'false'); drawer.setAttribute('aria-hidden', 'true'); };
    burger.addEventListener('click', () => document.body.classList.contains('menu-open') ? close() : open());
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  })();

  /* Calculateur de devis */
  (function () {
    const slider = document.getElementById('surfaceSlider');
    if (!slider) return;
    const sv = document.getElementById('surfaceVal');
    const pLow = document.getElementById('priceLow');
    const pHigh = document.getElementById('priceHigh');
    let type = null, factor = 1;
    document.querySelectorAll('.calc-opts[data-q="type"] .copt').forEach(b => {
      b.addEventListener('click', () => {
        document.querySelectorAll('.calc-opts[data-q="type"] .copt').forEach(x => x.classList.remove('sel'));
        b.classList.add('sel');
        type = { low: +b.dataset.low, high: +b.dataset.high };
        update();
      });
    });
    document.querySelectorAll('.calc-opts[data-q="finition"] .copt').forEach(b => {
      b.addEventListener('click', () => {
        document.querySelectorAll('.calc-opts[data-q="finition"] .copt').forEach(x => x.classList.remove('sel'));
        b.classList.add('sel');
        factor = +b.dataset.factor;
        update();
      });
    });
    slider.addEventListener('input', () => { sv.textContent = slider.value; update(); });
    function fmt(n) { return Math.round(n / 50) * 50; }
    function update() {
      if (!type) return;
      const s = +slider.value;
      pLow.textContent = fmt(s * type.low * factor).toLocaleString('fr-BE');
      pHigh.textContent = fmt(s * type.high * factor).toLocaleString('fr-BE');
    }
  })();

  /* Compteurs animés des stats */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    const animateCount = (el) => {
      const target = +el.dataset.count;
      const dur = 1600, start = performance.now();
      const tick = now => {
        const t = Math.min(1, (now - start) / dur);
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(target * eased);
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const so = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          animateCount(e.target);
          const stat = e.target.closest('.stat');
          if (stat) stat.classList.add('in-view');
          so.unobserve(e.target);
        }
      });
    }, { threshold: .4 });
    document.querySelectorAll('.stat-num .num').forEach(el => { el.textContent = '0'; so.observe(el); });
  })();

  /* Toggle cartes Garanties */
  document.querySelectorAll('.gcard[data-toggle]').forEach(card => {
    card.addEventListener('click', () => card.classList.toggle('open'));
  });

  /* Toggle "Lire plus" témoignages (mobile) — indépendant par carte, refermable.
     03/09/2026 : les deux libellés arrivent par data-more / data-less, posés par
     sections/testimonials.liquid depuis les fichiers de langue. Ecrits en dur ici,
     le bouton repassait en français dès le premier clic sur la version néerlandaise. */
  document.querySelectorAll('.quote-more').forEach(btn => {
    btn.addEventListener('click', () => {
      const q = btn.closest('.quote');
      if (!q) return;
      const open = q.classList.toggle('expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? (btn.dataset.less || 'Réduire') : (btn.dataset.more || 'Lire plus');
    });
  });

  /* Before / After sliders — revelation auto a l'entree + comparaison au doigt.
     Le glisser-deposer natif de l'image (fantome qui suit le curseur) annulait la capture
     du pointeur : plus aucun pointermove, le slider ne repondait qu'au clic. D'ou le
     preventDefault sur pointerdown + le blocage de dragstart. Voir le CSS de la section
     (pan-y, user-drag, touch-callout) : les deux moities vont ensemble. */
  document.querySelectorAll('.ba-slider').forEach(slider => {
    const before = slider.querySelector('.ba-before');
    const handle = slider.querySelector('.ba-handle');
    const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    let dragging = false, swept = false, pos = 50;
    function setPos(pct) {
      pos = Math.max(0, Math.min(100, pct));
      before.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
      handle.style.left = pos + '%';
      handle.setAttribute('aria-valuenow', Math.round(pos));
    }
    function onMove(clientX) {
      const r = slider.getBoundingClientRect();
      if (!r.width) return;
      setPos(((clientX - r.left) / r.width) * 100);
    }
    function touch() { slider.classList.add('touched'); slider.classList.remove('sweep'); }
    function stop() { dragging = false; slider.classList.remove('dragging'); }

    slider.addEventListener('dragstart', e => e.preventDefault());
    slider.addEventListener('pointerdown', e => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      touch();
      dragging = true;
      slider.classList.add('dragging');
      try { slider.setPointerCapture(e.pointerId); } catch (err) {}
      onMove(e.clientX);
    });
    slider.addEventListener('pointermove', e => { if (dragging) onMove(e.clientX); });
    slider.addEventListener('pointerup', stop);
    slider.addEventListener('pointercancel', stop);
    slider.addEventListener('lostpointercapture', stop);

    /* Clavier : le curseur est un vrai controle, atteignable en tabulation */
    handle.addEventListener('keydown', e => {
      const step = e.shiftKey ? 10 : 3;
      let handled = true;
      if (e.key === 'ArrowLeft') { setPos(pos - step); }
      else if (e.key === 'ArrowRight') { setPos(pos + step); }
      else if (e.key === 'Home') { setPos(0); }
      else if (e.key === 'End') { setPos(100); }
      else { handled = false; }
      if (handled) { touch(); e.preventDefault(); }
    });

    setPos(reduce ? 50 : 100);
    function sweep() {
      if (swept) return; swept = true;
      slider.classList.add('revealed');
      if (reduce) { setPos(50); return; }
      slider.classList.add('sweep');
      requestAnimationFrame(() => setPos(22));
      setTimeout(() => { if (!slider.classList.contains('touched')) setPos(55); }, 1150);
      setTimeout(() => slider.classList.remove('sweep'), 2350);
    }
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { es.forEach(en => { if (en.isIntersecting) { sweep(); io.disconnect(); } }); }, { threshold: 0.4 });
      io.observe(slider);
    } else { slider.classList.add('revealed'); setPos(50); }
  });

  /* Apparition des sections au scroll */
  (function () {
    if (!document.documentElement.classList.contains('anim-ready')) return;
    window.__revealInit = true;
    const show = el => el.classList.add('in');
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => {
        if (e.isIntersecting) { show(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    const observe = el => { if (!el.classList.contains('in')) io.observe(el); };
    document.querySelectorAll('.reveal').forEach(observe);
    window.addEventListener('load', () => setTimeout(() => {
      document.querySelectorAll('.reveal').forEach(el => {
        if (!el.classList.contains('in') && el.getBoundingClientRect().top < window.innerHeight) show(el);
      });
    }, 300));
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', e => {
        e.target.querySelectorAll('.reveal').forEach(show);
      });
    }
  })();

  /* Header allege au scroll */
  (function () {
    if (window.__vcgHeaderScroll) return; window.__vcgHeaderScroll = 1;
    var header = document.querySelector('header');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 8) { header.classList.add('scrolled'); }
      else { header.classList.remove('scrolled'); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

});